import { render, staticRenderFns } from "./LotFormatModal.vue?vue&type=template&id=818a3ca4&scoped=true"
import script from "./LotFormatModal.vue?vue&type=script&lang=js"
export * from "./LotFormatModal.vue?vue&type=script&lang=js"
import style0 from "./LotFormatModal.vue?vue&type=style&index=0&id=818a3ca4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "818a3ca4",
  null
  
)

export default component.exports